import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Download } from "lucide-react";

export default function Library() {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/library").then((r) => setBooks(r.data.books || [])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-[1360px] mx-auto px-6 lg:px-12 pt-16 pb-24">
      <div className="grid lg:grid-cols-12 gap-10 items-end mb-16">
        <div className="lg:col-span-8">
          <p className="eyebrow">Your Library</p>
          <h1 className="font-serif-display text-5xl sm:text-6xl leading-none tracking-tighter mt-6" data-testid="library-title">
            Books you<br/><em className="italic text-[#B85C38]">have to hand</em>.
          </h1>
        </div>
        <div className="lg:col-span-4 text-[#5C5C5C]">
          Lifetime access. Download the PDF whenever you need it — this is your shelf.
        </div>
      </div>

      <div className="hairline mb-16" />

      {loading ? (
        <p className="eyebrow">Loading</p>
      ) : books.length === 0 ? (
        <div className="text-center py-24 border border-dashed border-[#E5E2DC]">
          <p className="font-serif-display text-3xl">Your shelf is quiet.</p>
          <p className="text-[#5C5C5C] mt-3">No purchases yet — browse the catalog to find your first volume.</p>
          <Link to="/catalog" data-testid="empty-library-cta" className="btn-primary mt-8">Browse the catalog</Link>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-14">
          {books.map((b) => (
            <div key={b.id} data-testid={`library-book-${b.slug}`} className="group">
              <div className="aspect-[3/4] overflow-hidden bg-[#E5E2DC]">
                <img src={b.cover_image} alt={b.title} className="w-full h-full object-cover" />
              </div>
              <h3 className="font-serif-display text-2xl mt-5 leading-tight">{b.title}</h3>
              <p className="italic font-serif-display text-[#5C5C5C]">{b.subtitle}</p>
              <div className="mt-5 flex gap-3">
                <a href={b.pdf_url} target="_blank" rel="noreferrer" data-testid={`download-${b.slug}`} className="btn-primary flex-1 justify-center">
                  <Download size={14} /> Download
                </a>
                <Link to={`/book/${b.slug}`} className="btn-ghost">Read details</Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
